import { createReducer } from '@reduxjs/toolkit';

import {
    BACKEND_CREATE_DEDUCTION,
    STORE_REPLACE_DEDUCTION,
    STORE_REPLACE_DEDUCTION_ERROR,
    STORE_DEDUCTION_CLEAR_ERRORS,
    STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_AMOUNT_TO_CHARGE,
    STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_AMOUNT_TYPE,
    STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_COMPANY_NAME,
} from '@perpay-web/fintech/constants/actionTypes';
import { MINIMUM_REQUIRED } from '@perpay-web/fintech/constants/selectAmountTypes';

const initialState = {
    amountType: MINIMUM_REQUIRED,
    amountToCharge: 0,
    fetchingPinwheelToken: false,
    pinwheelErrors: {},
    selfOnboardingCompanyName: '',
};

const updateDirectDepositReducer = createReducer(initialState, (builder) => {
    builder.addCase(BACKEND_CREATE_DEDUCTION, (state) => ({
        ...state,
        fetchingPinwheelToken: true,
        pinwheelErrors: {},
    }));
    builder.addCase(STORE_REPLACE_DEDUCTION, (state) => ({
        ...state,
        fetchingPinwheelToken: false,
    }));
    builder.addCase(STORE_REPLACE_DEDUCTION_ERROR, (state, action) => ({
        ...state,
        fetchingPinwheelToken: false,
        pinwheelErrors: action.payload,
    }));
    builder.addCase(STORE_DEDUCTION_CLEAR_ERRORS, (state) => ({
        ...state,
        pinwheelErrors: {},
    }));
    builder.addCase(
        STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_AMOUNT_TO_CHARGE,
        (state, action) => ({
            ...state,
            amountToCharge: action.payload,
        }),
    );
    builder.addCase(
        STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_AMOUNT_TYPE,
        (state, action) => ({
            ...state,
            amountType: action.payload,
        }),
    );
    builder.addCase(
        STORE_UPDATE_DIRECT_DEPOSIT_REPLACE_COMPANY_NAME,
        (state, action) => ({
            ...state,
            selfOnboardingCompanyName: action.payload,
        }),
    );
});

export default updateDirectDepositReducer;
